import React, { useState } from 'react';
import Header from './Header';
import Hero from './Hero';
import Products from './Products';
import Footer from './Footer';
import ContactForm from './ContactForm';
import CookieConsent from './CookieConsent';

export default function Home() {
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <>
      <Header onContactClick={() => setIsContactOpen(true)} />
      <Hero />
      <Products />
      <Footer />
      <ContactForm isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />
      <CookieConsent />
    </>
  );
}
